import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import { useAuth } from "@/context/AuthContext";

export default function AuthSuccess() {
  const { user } = useAuth();
  const nav = useNavigate();
  const first = (user?.name || "").split(" ")[0];
  return (
    <AuthLayout>
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.2, 0.7, 0.2, 1] }}
      >
        <div className="lux-eyebrow">Welcome</div>
        <h1 className="mt-4 text-[24px] font-semibold tracking-tight text-nexa-ink">
          <span className="italic">A quiet handshake,</span> {first ? first + "." : "friend."}
        </h1>
        <p className="mt-6 lux-body max-w-[42ch]">
          Your workspace is prepared. Before your first morning brief, a few brief notes about your business —
          so the counsel you receive is tailored to what you actually do.
        </p>

        <div className="mt-12 flex items-center gap-3">
          <button
            data-testid="auth-success-continue-btn"
            onClick={() => nav("/business-setup")}
            className="lux-btn-primary"
          >
            Continue <ArrowRight className="w-4 h-4 ml-2" strokeWidth={1.5} />
          </button>
          <Link
            to="/dashboard"
            data-testid="auth-success-skip-link"
            className="lux-btn-quiet"
          >
            Skip for now
          </Link>
        </div>
      </motion.div>
    </AuthLayout>
  );
}
